import { Button, FormField, SpaceBetween, StatusIndicator ,Table} from '@amzn/awsui-components-react-v3';
import Modal from 'AWS-UI-Components-React/polaris/modal';
import React from 'react';
import { extractErrorMessage } from '../../../utilities';
import logger from '../../../utils/logging';
import { getJSClient } from '../../js_client';
import axios from 'axios'

const extensions = ['.csv'];

const amzSecurityToken = '?X-Amz-Security-Token';

export class FileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file:null,
      statusMessage:'',
      status:'',
      showFailedRows: false,
      failedRows:[],
      uploadDisabled: true,
      showReviewButton: false
    };
  }

  componentDidMount = () => {
    this.client = getJSClient();
  };

  handleFileChange = (event) => {
    if(event.target.files.length > 0) {
      const file = event.target.files[0];
      if(extensions.some((ex) => file.name.endsWith(ex))) {
        this.setState({file, uploadDisabled: false, showFailedRows: false, status: '', statusMessage: ''});
      } else {
        this.setState({uploadDisabled: true,
                        showFailedRows: false,
                        status:'error',
                        statusMessage: `Please select an ${extensions} file`});
      }
    }
  }

  onUpload =() => {
    const file = this.state.file;
    if(file) {
      this.setState({status: 'loading', statusMessage: 'Uploading file', showFailedRows: false, uploadDisabled: true});
      const fileType = file.name.split('.').pop();
      this.client.getPresignedS3Url(
        (result) => {
          this.uploadFileWithPresignedS3Url(result, file);
        },
        (error) => {
          this.setState({status:'error',statusMessage: extractErrorMessage(error)})
        },
        {username: this.props.user, fileType: fileType}
      )
    }
  }


  uploadFileWithPresignedS3Url = (result, file) => {
    const presignedUrl = result.s3Url;
    axios.put(presignedUrl,file,{headers: {"Content-Type": file.type}})
         .then(() => {
           this.setState({status: 'loading', statusMessage: 'Upload Complete, waiting for validation',})
           const s3url = this.removePresignedToken(presignedUrl);
           this.client.saveBenchmarkAdjustmentDraft(
             (result) => {this.onSaveBenchmarkAdjustmentDraftSuccess(result)},
             (error) => {this.onSaveBenchmarkAdjustmentDraftFailure(error)},
             {s3Url: s3url}
           )
         })
         .catch((error) => {
           logger.error(extractErrorMessage(error), error);
           this.setState({status:'error', statusMessage: 'Upload Failed: ' + extractErrorMessage(error)})
         });
  }

  onSaveBenchmarkAdjustmentDraftSuccess = (result) => {
    const showFailedRows = result.unsavedItems.length !== 0;
    const showReviewButton = result.totalCount > result.unsavedItems.length;
    let status = '';
    let statusMessage = '';
    if (result.totalCount === 0) {
      status = 'info';
      statusMessage = 'No changes found in uploaded file.';
    } else if (result.totalCount > result.unsavedItems.length) {
      status = 'success';
      statusMessage = `${ result.totalCount } changes found in file, ${ result.totalCount - result.unsavedItems.length } row(s) saved to draft.`
    }
    this.setState( { showFailedRows, showReviewButton, status, statusMessage, failedRows: result.unsavedItems})
  }

  onSaveBenchmarkAdjustmentDraftFailure = (error) => {
    this.setState({status: 'error', statusMessage: extractErrorMessage(error)})
  }

  removePresignedToken = (presignedUrl) => {
    if (presignedUrl.length < 1) {
      return '';
    }
    return presignedUrl.split(amzSecurityToken)[0];
  }

  getColumnDefinitions = () => {
    return [
      {
        id: 'month',
        header: 'Month',
        cell: (item) => item.month,
      },
      {
        id: 'account',
        header: 'Account',
        cell: (item) => item.account,
      },
      {
        id: 'marketplace',
        header: 'Marketplace',
        cell: (item) => item.marketplace,
      },
      {
        id: 'channel',
        header: 'Channel',
        cell: (item) => item.channel,
      },
      {
        id: 'pl',
        header: 'PL',
        cell: (item) => item.pl,
      },
      {
        id: 'amount',
        header: 'Amount',
        cell: (item) => item.amount,
      },
      {
        id: 'comments',
        header: 'Comments',
        cell: (item) => item.comments,
      },
      {
        id: 'update_record',
        header: 'Is Update Record',
        cell: (item) => item.updateRecord,
      },
    ];
  };

  render() {
    const {
      status,
      statusMessage,
      showFailedRows,
      failedRows,
      uploadDisabled,
      showReviewButton
    } = this.state;
    return (
      <Modal
        visible={true}
        size="large"
        expandToFit={true}
        onDismiss={this.props.onUploadDismiss}
        header="Upload File"
        footer={
          <span className="awsui-util-f-r">
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="primary" icon="upload" onClick={ this.onUpload } disabled={ uploadDisabled }>
                Upload
              </Button>
              <Button variant="normal" icon="upload" onClick={ () => this.props.onUploadDismiss(showReviewButton) }>
                Close
              </Button>
              {showReviewButton && (
              <Button variant="primary" icon="upload" onClick={ () => this.props.onUploadDismiss(true) }>
                Review Draft
              </Button>)
              }
            </SpaceBetween>
          </span>
        }
      >
        <FormField
          id="fileUploadChooser"
          label={`Choose a ${extensions} file`}
          description="Choose a file with updates to upload."
          hintText="Download the template as a starter."
        >
          <input
            type="file"
            accept={extensions.join(",")}
            onChange={this.handleFileChange}
            multiple={false}
          />
          {status && (
            <StatusIndicator type={status}>
              {statusMessage}
            </StatusIndicator>)}
        </FormField>
        {showFailedRows && (
          <div>
            <StatusIndicator type="error">
              {failedRows.length} invalid row(s) found:
            </StatusIndicator>
            <Table
              columnDefinitions={this.getColumnDefinitions()}
              items={failedRows}
              empty={'No invalid rows.'}
              stickyHeader>
            </Table>
          </div>
        )}
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/config_central/benchmark_adjustment/file_upload.jsx